import { render, staticRenderFns } from "./FilterBox.vue?vue&type=template&id=04f84b6c&scoped=true&"
import script from "./FilterBox.vue?vue&type=script&lang=js&"
export * from "./FilterBox.vue?vue&type=script&lang=js&"
import style0 from "./FilterBox.vue?vue&type=style&index=0&id=04f84b6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f84b6c",
  null
  
)

export default component.exports